import { apiHelper } from '@/utils'
import { API } from '@/constants'

/**
 * Proposals — briefs the bot collected and the documents drafted from them.
 *
 * ai_bot owns the lead and the proposal versions; the console lists, edits
 * (including the prices, which only a person types), previews the PDF and
 * sends. See the backend's ProposalController.
 */
export const proposalService = {
  listBriefs,
  getCatalogue,
  getProposal,
  generate,
  save,
  pdfBlob,
  send,
}

const API_URL = API.BASE_URL + '/v1'

export async function listBriefs(tenantId) {
  return apiHelper(API_URL).get('/proposals', { params: { tenant_id: tenantId } })
}

/** The brand's programme catalogue — what sales can pick from. */
export async function getCatalogue(tenantId) {
  return apiHelper(API_URL).get('/proposals/catalogue', { params: { tenant_id: tenantId } })
}

export async function getProposal(leadRef) {
  return apiHelper(API_URL).get(`/proposals/${leadRef}`)
}

/** One large model call; the backend allows up to two minutes. */
export async function generate(leadRef) {
  return apiHelper(API_URL).post(`/proposals/${leadRef}/generate`, {}, { timeout: 150000 })
}

export async function save(leadRef, content, status) {
  return apiHelper(API_URL).put(`/proposals/${leadRef}`, { content, ...(status ? { status } : {}) })
}

/** The PDF bytes, for an in-browser preview (object URL). */
export async function pdfBlob(leadRef) {
  return apiHelper(API_URL).get(`/proposals/${leadRef}/pdf`, { responseType: 'blob' })
}

export async function send(leadRef, to, message) {
  return apiHelper(API_URL).post(`/proposals/${leadRef}/send`, { to, message }, { timeout: 60000 })
}
